import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import baseUrl from "../../../api/universalApi";
import { useNavigate } from "react-router-dom";

const Contract = () => {
  const user = useSelector((state) => state.auth?.authData?.user);
  const [contracts, setContracts] = useState([]);
 // console.log("User Data:", user);
 const navigate = useNavigate()

  const fetchContractDetails = async (email) => {
    // This function can be used to fetch contract details if needed
    console.log("Fetching contract details for user:", email);
    try {
      const response = await fetch(
        `${baseUrl}/api/agreement/getContractByEmail`,
        {
          method: "POST",
          headers: {
        "Content-Type": "application/json",
        // Add any necessary authentication headers here
          },
          body: JSON.stringify({ email:email }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch contract details");
      }
      const data = await response.json();
      console.log("Contract Details:", data);
      setContracts(data)
    } catch (error) {
      console.error("Error fetching contract details:", error);
    }
    // Example: await fetch(`/api/contracts/${user.id}`);
  };

  useEffect(() => {
    if (user?.email) {
    console.log("Calling fetchContractDetails with:", user.email);
    fetchContractDetails(user.email);
  }
  }, [user?.email]);

  return (
    <>
      <div className="flex flex-wrap gap-4">
        {contracts.map((contract, idx) => (
          <div
            key={contract._id || idx}
            className="border border-gray-300 rounded-lg p-4 min-w-[220px] bg-white shadow-md"
            onClick={()=>navigate(`/signContract/${contract?.campaign_id?._id}`)}
          >
            <h3 className="mb-2 text-lg font-semibold">
              {contract.company || "No Company"}
            </h3>
            {/* Add more contract details here if needed */}
          </div>
        ))}
      </div>
    </>
  );
};

export default Contract;
